<template lang="pug">

    tbody

        //- View
        tr
            td
                strong {{ label }}
            td  {{ viewValue }}
            td.right.aligned
                a(v-if="$route.name !== 'quality-rating'" v-on:click='toggleEditMode()' v-show='!isEditModeActive')
                    i.edit.icon
                a(v-if="$route.name !== 'quality-rating'" v-on:click='toggleEditMode()' v-show='isEditModeActive' v-tooltip='"Abbrechen"')
                    i.remove.icon

        //- Editable
        tr(v-show='isEditModeActive')

            td(colspan='3')

                .ui.fluid.action.input
                    input(type='text' v-bind:value='viewValue' readonly)

                    //- Speichern-Button
                    button.ui.icon.button(type='button' v-on:click='save()')
                        i.checkmark.icon

</template>

<script>
    import Pikaday from 'pikaday'
    import { string_to_readable as date_string_to_readable }  from '@/utils/date'
    import { to_yyyymmddd as date_to_yyyymmdd}  from '@/utils/date'

    export default {

        computed: {
            viewValue() {
                return date_string_to_readable(this.value[this.property])
            }
        },

        data() {
            return {
                isEditModeActive: false
            }
        },

        methods: {

            save() {
                // Payload erstellen
                const date  = date_to_yyyymmdd(this.picker.getDate())
                const model = { ...this.value, [this.property]: date }

                // Model patchen
                this.$store.dispatch('products/update', { id: model.id, model }).then(() => {
                    // Edit-Mode deaktivieren
                    this.toggleEditMode()

                    // Message anzeige
                    this.$growl.success(`${this.label} wurde aktualisiert`)
                }).catch(e => {
                    this.$growl.fatal(`${this.label} konnte nicht gespeichert werden`, e)
                })
            },

            toggleEditMode() {
                this.isEditModeActive = !this.isEditModeActive

                // Textfeld fokusieren
                if (this.isEditModeActive) {
                    this.$nextTick(() => this.picker.show())
                }
            }
        },

        mounted() {
            // Pikaday initialisiren und konfigurieren
            this.picker = new Pikaday({
                field: this.$el.querySelector('input'),
                firstDay: 1,
                format: 'DD.MM.YYYY'
            })
        },

        props: {
            value: {
                required: true
            },
            label: {
                type: String,
                required: true
            },
            property: {
                type: String,
                required: true
            }
        }

    }

</script>

<style>

    @import url('../../../../node_modules/pikaday/css/pikaday.css');

</style>
